const SilverUniteLog = require('@ali/silver-unite-log')

class Data {
  constructor() {
    this.uLog = null
    this.log = {}
    this.data = {
      act_url: window.location.href
    }
    this.init()
  }

  init() {
    let opt = {}

    if (window._DATA && window._DATA.moduleinfo) {
      const moduleinfo = window._DATA.moduleinfo

      // TODO ark_verison写错单词了,不能删除,用于BI数据收集
      this.data.ark_verison = moduleinfo.version || 'codepage'
      this.data.ark_version = moduleinfo.version || 'codepage'
      this.data.sys_verison = moduleinfo.version || 'codepage'
      this.data.act_id = moduleinfo.pageId || ''
      this.log = moduleinfo.log || this.log

      if (this.log.code && this.log.key) {
        opt = {
          code: this.log.code,
          key: this.log.key
        }
      }
    }
    this.uLog = new SilverUniteLog(opt)
    this.setGlobal()

    return this
  }

  setGlobal(data) {
    this._makeTVData()
    this._makeData()

    if (data) {
      for (let k in data) {
        if (data.hasOwnProperty(k)) {
          this.data[k] = data[k]
        }
      }
    }

    this.uLog.setGlobal(this.data)
    return this
  }

  event(data) {
    this.uLog.event(data)
    return this
  }

  exposure(data) {
    this.uLog.exposure(data)
    return this
  }

  _makeData() {
    this.data.act_name = this.log.name || window.document.title
  }

  _makeTVData() {
    if (!window.tv) {
      return
    }
    if (window.tv.getUUid) {
      this.data.uuid = window.tv.getUUid()
    }
    if (window.tv.getLoginID) {
      const nick = window.tv.getLoginID()
      if (nick) {
        this.data.is_login = true
        this.data.user_id = nick
      }
    }
    if (window.tv.getYoukuLoginInfo) {
      let use = window.tv.getYoukuLoginInfo()
      if (use) {
        try {
          use = JSON.parse(use)
        } catch (e) {
          use = {}
        }
      } else {
        use = {}
      }
      if (use.userName) {
        this.data.is_login_from_youku = true
        this.data.youku_name = use.userName
        this.data.youku_id = use.ykID
      }
    }
  }
}

export const Log = new Data()



// WEBPACK FOOTER //
// ./src/page/main/log.js